import { Reveal } from "@/components/campaign/Reveal";

const PROBLEMS = [
  {
    title: "Your care happens in pieces.",
    body: "Different doctors, different tests \u2014 and nobody looks at them together. You end up carrying the full picture alone.",
    review: {
      name: "Jessica Batha",
      image: "/images/reviews/jessica-batha.webp",
      imageAlt: "Jessica Batha with her family",
      imagePosition: "50% 44%",
      quote:
        "Dr Jill was very thorough in connecting the dots between different tests ordered by different doctors. Her whole person analysis and time and care were greatly appreciated!",
    },
  },
  {
    title: "Ten minutes isn\u2019t enough.",
    body: "Rushed visits leave your real questions unanswered \u2014 and you back home, still wondering what\u2019s actually going on.",
    review: {
      name: "Susan Hammerstone",
      image: "/images/reviews/susan-hammerstone.webp",
      imageAlt: "Susan Hammerstone with her son",
      imagePosition: "50% 30%",
      quote:
        "She listened to all of my concerns and explained everything in detail, going over options for bloodwork and other tests as well as where we could start with a plan for care.",
    },
  },
  {
    title: "You want the whole picture.",
    body: "Sleep, energy, digestion, weight, mood and hormones are connected. Care that ignores those connections leaves you managing each symptom alone.",
    review: {
      name: "Grace",
      image: "/images/reviews/grace.webp",
      imageAlt: "Grace with her family at the beach",
      imagePosition: "50% 32%",
      quote: "Dr. Jill Crosson is an exceptional physician who truly listens and treats the whole person.",
    },
  },
];

export const FmProblems = () => (
  <section data-testid="fm-problems-section" className="py-16 sm:py-24 bg-[var(--brand-navy-deep)] text-white">
    <div className="max-w-6xl mx-auto px-4 sm:px-6">
      <Reveal>
        <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] text-[var(--brand-gold)]">
          Sound familiar?
        </p>
        <h2 className="mt-3 font-serif-brand text-3xl sm:text-4xl font-medium leading-tight max-w-2xl">
          When no one looks at the whole picture, you feel it.
        </h2>
      </Reveal>
      <div className="mt-12 grid md:grid-cols-3 gap-8">
        {PROBLEMS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.12}>
            <div data-testid={`fm-problem-card-${i + 1}`} className="flex h-full flex-col">
              <h3 className="font-serif-brand text-2xl font-medium text-[var(--brand-gold)]">{p.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-white/85">{p.body}</p>
              <figure className="mt-6 flex-1 bg-white/[0.06] border border-white/10 p-5">
                <img
                  src={p.review.image}
                  alt={p.review.imageAlt}
                  className="h-14 w-14 rounded-full object-cover border-2 border-[var(--brand-gold)]"
                  style={{ objectPosition: p.review.imagePosition }}
                  loading="lazy"
                />
                <blockquote className="mt-4 text-[15px] leading-relaxed text-white/90">
                  &ldquo;{p.review.quote}&rdquo;
                </blockquote>
                <figcaption className="mt-3 text-sm text-white/70">
                  &mdash; {p.review.name} &bull; Verified Google Review
                </figcaption>
              </figure>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
